<template>
  <div class="model_client_order">
    <div class="model_client_order__header">
      <h4 class="title">
        {{ translate("client_order.new") }}
      </h4>
    </div>

    <div class="model_client_order__body">
      <div class="client_order">
        <div class="block">
          <div class="block_wrap">

            <div class="line">
              <div class="input_wrap main_name">
                <fg-input
                    v-model="primary_data.name"
                    type="text"
                    :label="translate('client_order.name')"
                    :placeholder="translate('client_order.name')"
                    :clearable="true"
                />
              </div>
            </div>

            <div class="line">
              <div class="form_select input_wrap parent_company">
                  <WrapDatePicker
                      type="date"
                      value_type="X"
                      v-model="primary_data.ts_date"
                      :range="false"
                      :confirm="false"
                      :disabled_date="['- 3 month', '+ 1 month']"
                      :placeholder="translate('client_order.date')"
                      :label="translate('client_order.date')"
                  />
              </div>

              <div class="input_wrap">
                <label>
                  {{ translate('client_order.type') }}
                </label>
                <tree-select
                    :options="type_list"
                    :placeholder="translate('client_order.type')"
                    v-model="primary_data.type"
                    :clearable="false"
                    :multiple="false"
                />
              </div>
            </div>

            <div class="line">
              <div class="input_wrap parent_company">
                <label>
                  {{ translate('client_order.client') }}
                </label>
                <tree-select
                    :options="client_list"
                    :placeholder="translate('client_order.client')"
                    v-model="primary_data.client_id"
                    :clearable="false"
                    :multiple="false"
                    @input="change_name"
                />
              </div>

              <div class="input_wrap parent_company">
                <label>
                  {{ translate('client_order.customer_user_name') }}
                </label>
                <tree-select
                    :options="company_user_list"
                    :placeholder="translate('client_order.customer_user_name')"
                    v-model="primary_data.customer_user_id"
                    :clearable="false"
                    :multiple="false"
                />
              </div>
            </div>

            <div class="line">

              <div class="input_wrap parent_company">
                <label>
                  {{ translate('client_order.device_sku') }}
                </label>
                <tree-select
                    :options="device_sku_list"
                    :placeholder="translate('client_order.device_sku')"
                    v-model="primary_data.device_sku_id"
                    :clearable="true"
                    :multiple="false"
                />
              </div>

              <div class="input_wrap main_device_count">
                <fg-input
                    v-model="primary_data.device_count"
                    type="number"
                    :min="0"
                    :label="translate('client_order.device_count')"
                    :placeholder="translate('client_order.device_count')"
                />
              </div>

              <div class="input_wrap main_name">
                <fg-input
                    v-model="primary_data.order_form"
                    type="text"
                    :label="translate('client_order.order_form')"
                    :placeholder="translate('client_order.order_form')"
                    :clearable="true"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="model_client_order__footer">
      <span
          :disabled="check_count"
          class="btn btn-success btn-fill btn-wd"
          @click.prevent="create_client_order"
      >
        {{ translate('btn.create') }}
      </span>
      <span
        class="btn btn-danger btn-fill btn-wd"
        @click.prevent="close_modal"
      >
        {{ translate('close_modal') }}
      </span>
    </div>

  </div>
</template>
<script>


import WrapDatePicker from "components/UIComponents/WrapDatePicker/WrapDatePicker.vue";

export default {
  name: 'ClientOrderModal',
  components: {WrapDatePicker},
  data () {
    return {
      primary_data: {
        id: null,
        name: "",
        client_id: null,
        customer_user_id: null,
        device_count: "",
        order_form: "",
        ts_date: null,
        date: null,
        type: 2,
        status: 0,
        device_sku_id: null
      },
      loading: true,
      filter_link: null
    }
  },
  computed:{
    type_list(){
      return this.$store.getters.getClientOrdersInfo.types.map((entry) => {
        return {id: entry.id, label: this.translate("client_order.type_orders." + entry.title)}
      })
    },
    client_list(){
      return this.$store.getters.getClientsList.map((client) => {
        return {label: client.name, id: client.id}
      })
    },

    company_user_list(){
      return this.$store.getters.getCompanyUserList.map((user) => {
        return {label: user.name, id: user.id}
      })
    },
    device_sku_list(){
      return this.$store.getters.getDeviceSkus.map((sku) => {
        return {label: sku.name, id: sku.id}
      })
    },

    check_count(){
      return this.primary_data.device_count === "" || this.primary_data.device_count < 0
    }
  },

  methods: {
    change_name(){
      if (this.primary_data.client_id !== null){
        let client = this.client_list.find((item) => {
          if (item.id === this.primary_data.client_id) return item
        })
        this.primary_data.name = this.primary_data.name === "" ? this.primary_data.name = client.label : this.primary_data.name
      }
    },
    create_client_order(){
      if (!this.check_count){
        if (this.primary_data.device_sku_id === null){
          this.global_notify('danger', this.translate('client_order.device_sku_not_specified'))
          return
        }

        this.primary_data.date = this.getDateYYYMMDD(this.primary_data.ts_date)
        this.primary_data.device_count = Number(this.primary_data.device_count)

        this.$http.v1.createClientOrder(this.primary_data, (response) => {
          this.global_notify('info', this.translate('client_order.saved_success'))
          this.update()
          this.$router.push({path: '/client_order/' + response.data.id})
          this.close_modal()
        })
      }
    },
    update(){
      this.$emit('update')
    },
    close_modal () {
      this.$emit('close')
    }
  }
}

</script>

<style lang='scss' scoped>
  .model_client_order{
    height: 100%;
    padding: 10px;
    &__header{
      display: flex;
      align-items: center;
      padding-bottom: 10px;
      .title{
        width: 100%;
        margin: 0;
        text-align: center;
      }
      .links{
        width: 30%;
        & > .vue-treeselect{
          margin-bottom: 0;
        }
      }
    }
    &__body{
      width: 100%;
      //height: 100%;
      height: 600px;
      .client_order{
        width: 100%;
        height: 100%;
        .block{
          height: calc(100% - 35px);
          border: 1px solid #efe9e9;
          margin-top: -1px;
          padding: 10px;
          overflow-y: auto;
          .line{
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .input_wrap{
              width: 100%;
              text-align: start;
              margin-bottom: 10px;
              display: flex;
              flex-direction: column;
              margin-right: 10px;
              &:last-child{
                margin-right: 0;
              }
              .form-control{

                width: 100%;
              }
            }
          }

          &::-webkit-scrollbar{
            width: 10px;
          }
        }
      }

    }
    &__footer{
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 10px;
      .btn{
        margin: 0 10px 0 0;
        &:last-child{
          margin-right: 0;
        }
      }
    }
  }
  .pointer{
    cursor: pointer;
    &:hover{
      background-color: #f3f3f3;
    }
  }
  .form-group,
  .vue-treeselect{
    margin-bottom: 0;
  }


</style>
